import styled from 'styled-components';
import { halfStep } from 'tokens';

interface BaseProps {
	disabled?: boolean;
}

export const Base = styled.div<BaseProps>`
	display: flex;
	align-items: auto;
	gap: 8px;
	padding-left: 8px;

	width: 100%;
	height: 40px;
	overflow: hidden;

	color: ${({ theme, disabled }) => (disabled ? theme.gray[600] : theme.gray[1000])};

	background: ${({ theme, disabled }) => (disabled ? theme.gray[200] : theme.gray[100])};

	border-radius: ${halfStep}px;
	user-select: none;
	opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const Options = styled.div`
	display: flex;
	align-items: center;
	gap: 0px;
	width: 100%;
`;

interface OptionButtonProperties {
	selected: boolean;
	disabled?: boolean;
}
export const OptionButton = styled.button<OptionButtonProperties>`
	background: transparent;
	color: ${({ theme, selected, disabled }) => {
		if (disabled) return theme.gray[400];
		return selected ? theme.gray[1000] : theme.gray[600];
	}};
	font-weight: ${({ selected }) => (selected ? '500' : '200')};
	height: 100%;
	width: 100%;
	border: none;
	padding: 0;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	&:hover {
		background: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray[100])};
	}
	padding-bottom: 2px;
`;

interface OptionLabelProperties {
	selected: boolean;
	disabled?: boolean;
}
export const OptionLabel = styled.span<OptionLabelProperties>`
	border: 1px solid
		${({ theme, selected, disabled }) => {
			if (disabled) return theme.gray[200];
			return selected ? theme.gray[400] : 'transparent';
		}};
	padding: 4px 8px;
	margin: 0;
	border-radius: 8px;
	font-size: 11px;
	background: ${({ theme, selected, disabled }) => {
		if (disabled) return theme.gray[200];
		return selected ? theme.gray[200] : 'transparent';
	}};
	&:hover {
		background: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray[200])};
	}
`;

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
`;
